import styled from 'styled-components';
import {Card, Space} from 'antd';
import {typographyStyles} from '../../../../../utils/styles';

const StyledCompanies = styled(Card)`
  .ant-card-head {
    flex-direction: unset;
  }

  .ant-card-body {
    padding: 0;
  }
`;

const StyledCompanyItem = styled(Space)`
  padding: 16px;
  width: 100%;

  .ant-space-item {
    &:first-of-type {
      ${typographyStyles.heading.h5};
      color: ${props => props.theme.colors.neutral_10};
    }
  }
  &:not(:last-of-type) {
    border-bottom: 1px solid ${props => props.theme.colors.neutral_4};
  }
`;

export {
  StyledCompanies,
  StyledCompanyItem
}
